module.exports = __webpack_public_path__ + "static/media/content-lib.f008c777.png";